(function () {
  'use strict';UpdatePaymentController.$inject = ["$rootScope", "$state", "$stateParams", "Authentication", "$window", "$analytics", "Intercom", "$http", "$location", "Profile", "gplansConf"];

  angular.
  module('gplans.store.controllers').
  controller('UpdatePaymentController', UpdatePaymentController);

  UpdatePaymentController.$inject = ['$rootScope', '$state', '$stateParams', 'Authentication', '$window', '$analytics',
  'Intercom', '$http', '$location', 'Profile', 'gplansConf'];

  /**
                                                               * @namespace UpdatePaymentController
                                                               */
  function UpdatePaymentController($rootScope, $state, $stateParams, Authentication, $window, $analytics, Intercom,
  $http, $location, Profile, gplansConf) {
    var vm = this;
    vm.recurlySubmit = recurlySubmit;
    vm.upToDate = false;
    vm.uidNotFound = false;

    activate();

    function activate() {
      var uid = $stateParams.uid;
      $http.get(gplansConf.API_URL + '/api/v1/auth/uid/' + uid + '/').then(function (res) {
        var token = res.data.token;
        vm.user = res.data.user;
        vm.upToDate = vm.user.payment_method === 'RECURLY';
        Authentication.setToken(token);
        Authentication.check();
      }).catch(function (err) {
        vm.uidNotFound = true;
      });
    }

    function recurlySubmit(result) {
      vm.showValidation = true;
      vm.loading = true;
      var oOrder = {};
      oOrder.expiration = {};
      var expiration = result.expiry.replace(/\s/g, '').split('/');
      oOrder.expiration.month = expiration[0];
      oOrder.expiration.year = expiration[1];
      oOrder.cc_number = result.number;
      oOrder.cvv = result.cvv;
      $http.post(gplansConf.API_URL + '/api/v1/update-payment/', { order: oOrder }).then(function (res) {
        vm.loading = false;
        if (res.data.success) {
          location.href = '/app/dash/';
        } else {alert('Something went wrong. Please contact us at support@g-plans.com.');}
      }, function (err) {
        vm.loading = false;
        alert('Something went wrong. Please contact us at support@g-plans.com.');
      }).catch(function (err) {
        alert('Something went wrong. Please contact us at support@g-plans.com.');
      });
    }
  }
})();